export const defaultVariant = 'standard'
export const defaultColor = 'primary'

export const eventObject = (eventKey, value) => {
  return { 
    target: { 
      [eventKey]: value
    }
  }
}